import React from 'react';
import { CheckCircle, AlertTriangle, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './EvidenceStepper.css';

const STEPS = [
  { id: 'documents', nameKey: 'reports.workspace.stepper.documents' },
  { id: 'extraction', nameKey: 'reports.workspace.stepper.extraction' },
  { id: 'evidence', nameKey: 'reports.workspace.stepper.evidence' },
  { id: 'assembled', nameKey: 'reports.workspace.stepper.assembled' },
  { id: 'preview', nameKey: 'reports.workspace.stepper.preview' },
  { id: 'export', nameKey: 'reports.workspace.stepper.export' },
];

export function EvidenceStepper({
  onStepClick,
  maxReachedStepIndex = 0,
  activeStepIndex,
}) {
  const { t } = useTranslation();
  const normalizedMaxIndex = Number.isInteger(maxReachedStepIndex)
    ? maxReachedStepIndex
    : 0;
  const clampedMaxIndex = Math.min(
    Math.max(normalizedMaxIndex, 0),
    STEPS.length - 1,
  );
  const normalizedActiveIndex = Number.isInteger(activeStepIndex)
    ? activeStepIndex
    : clampedMaxIndex;
  const clampedActiveIndex = Math.min(
    Math.max(normalizedActiveIndex, 0),
    STEPS.length - 1,
  );
  const steps = STEPS.map((step, index) => ({
    ...step,
    name: t(step.nameKey),
    status:
      index < clampedActiveIndex
        ? 'success'
        : index === clampedActiveIndex
          ? 'active'
          : 'pending',
  }));
  const progressPercentage =
    steps.length > 1 ? (clampedActiveIndex / (steps.length - 1)) * 100 : 0;

  const handleStepClick = (stepId, index) => {
    if (index <= clampedMaxIndex) {
      onStepClick(stepId);
    }
  };

  return (
    <div className="evidence-stepper">
      <div className="evidence-stepper__container">
        <div className="evidence-stepper__line">
          <div
            className="evidence-stepper__line-fill"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
        
        {steps.map((step, index) => (
          <div
            key={step.id}
            className={`evidence-stepper__step evidence-stepper__step--${step.status}`}
            onClick={() => handleStepClick(step.id, index)}
          >
            <div className="evidence-stepper__step-circle">
              {step.status === 'success' && <CheckCircle size={20} />}
              {step.status === 'warning' && <AlertTriangle size={20} />}
              {step.status === 'failed' && <X size={20} />}
              {(step.status === 'pending' || step.status === 'active') && (
                <span>{index + 1}</span>
              )}
            </div>
            <div className="evidence-stepper__step-label">{step.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
